<svelte:head>

    <link rel="stylesheet" type="text/css" href="/global.css" />
    <link rel="stylesheet" type="text/css" href="css/forms.css" />

</svelte:head>

<script>

    import { onMount } from "svelte";
    import { setContext, getContext } from "svelte";
    import { fade } from 'svelte/transition';
    import { sessionId, onboardingInfo } from "../../utils/store";
    import Plan from "./plan.svelte";

    import {
        errorReasons,
        plansMonthly,
        logout
    } from "../api.svelte";

    import {
        getLocalSessionId,
        getLocalUserStatus,
        getStatusRoute,
        sessionCleanup
    } from "../../utils/session";


    const router = getContext('router');

    let plans;

    // TODO: Adapt currency to country
    let currency = 'chf';
    let subtext = 'Pro Monat und Standort';
    let buttonText = 'Auswählen';


    onMount(() => {

        let localSessionId = getLocalSessionId();
        let localStatus = getLocalUserStatus();

        if (!localSessionId || !localStatus) {

            router.route('/login');
            return;

        }

        if (localStatus !== 'onboarding_plans'
            && localStatus !== 'onboarding_payment') {

            router.route(getStatusRoute(localStatus));
            return;

        }

        plansMonthly(currency).then((plansResult) => {

            if (plansResult['status'] !== 'success') {

                // TODO: Errore handling I guess
                return;
            }

            plans = plansResult['plans'];

        });

    });

    let planSelectedHandler = (evt) => {

        let localOnboardingInfo = {
            //'planId': evt.detail['planId'],
            'currency': currency,
            'tier': evt.detail['tier']
        };

        onboardingInfo.set(localOnboardingInfo);
        localStorage.setItem('kstatus', 'onboarding_payment');
        localStorage.setItem('konboardinginfo', JSON.stringify(localOnboardingInfo));

        router.route('/payment');

    };

    let logoutHandler = () => {

        logout().then((_) => {

            sessionId.set('');
            sessionCleanup();
            router.route('/login');

        });

    };

</script>


<div class="onboarding-logout" on:click={() => logoutHandler()}>

    <img src="/images/icons/nav/logout.svg" alt="">
    <span>Logout</span>

</div>

<div class="plans-container">

    {#if plans}

        <Plan
                planId={plans['standard']['id']}
                tier="standard"
                title="Standard"
                price={plans['standard']['amount']}
                currency={currency}
                subtext={subtext}
                items={[
                    "Bewertungen werden alle 48 Stunden aktualisiert",
                    "Zwei Integrationen pro Standort",
                    "Antwort auf Support-Anfragen während Geschäftszeiten innerhalb von 24 Stunden"
                ]}
                buttonText={buttonText}
                on:selected={planSelectedHandler}
        />

        <Plan
                planId={plans['premium']['id']}
                tier="premium"
                title="Premium"
                price={plans['premium']['amount']}
                currency={currency}
                subtext={subtext}
                items={[
                    "Bewertungen werden alle 24 Stunden aktualisiert",
                    "Jede Integration für jeden Standort",
                    "Antwort auf Support-Anfragen während Geschäftszeiten innerhalb von 2 Stunden"
                ]}
                buttonText={buttonText}
                on:selected={planSelectedHandler}
        />

    {/if}

</div>


<style>

    .plans-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        width: 102.6vh;
        height: fit-content;
    }

    @media screen and (max-width: 1024px) {

        .plans-container {
            flex-direction: column;
            align-items: center;
            width: 95vw;
            margin-top: 8vw;
            margin-bottom: 16vw;
        }

        .plans-container > :global(div:first-child) {
            margin-bottom: 6vw;
        }

    }

</style>
